module.exports.COMMENT_TYPE_PRICE_DISCREPANCY = 'priceDiscrepancy';
module.exports.COMMENT_TYPE_MANUAL_FINAL_PL = 'manualFinalPL';
